<div *ngIf="isActive">
	<!-- NO FLY TIME DISPLAY -->
	<div
		cdkOverlayOrigin
		#thirdOverlayTrigger="cdkOverlayOrigin"
		class="no-fly-time-bubble"
		(mouseenter)="showNoFlyTimeTooltip()"
		(mouseleave)="closeNoFlyTimeTooltip()">
		<img class="no-fly-time-icon" [src]="'./assets/no-fly-time (2).svg' | resolveAsset" />
		<span *ngIf="until">UNTIL {{ until }}</span>
	</div>
	<!-- END NO FLY TIME DISPLAY -->

	<!-- NO FLY TIME TOOLTIP -->
	<ng-template
		cdkConnectedOverlay
		[cdkConnectedOverlayOrigin]="thirdOverlayTrigger"
		[cdkConnectedOverlayOpen]="isOpenNoFlyTimeTooltip"
		[cdkConnectedOverlayWidth]="197"
		[cdkConnectedOverlayHeight]="noFlyTimeTooltipHeight"
		[cdkConnectedOverlayPositions]="noFlyTimeTooltipPosition">
		<app-no-fly-time-tooltip
			*ngIf="isActive && !hasActivePassRequest"
			[noFlyTimes]="noFlyTimes"
			[tooltipType]="'staff'"
			[isStaff]="true"
			[@TooltipFadeInOut]="'visible'"
			[currentNoFlyTimeIndex]="currentNoFlyTimeIndex"
			(mouseleave)="closeNoFlyTimeTooltip()"
			(mouseover)="showNoFlyTimeTooltip()">
		</app-no-fly-time-tooltip>
	</ng-template>
	<!-- END NO FLY TIME TOOLTIP -->
</div>
